import styled from '@emotion/styled';
import { Slide } from '@mui/material';
import { breakpoints, DisplayCard } from 'src/ui-components';

import { useTableData } from '../hooks/useTableData';
import { SparklineBlock, TopProductsSkeletonBuilder } from './SparklineBlock';

export const SparklineView = () => {
  const { data, loading } = useTableData();

  return (
    <Slide in direction="up">
      <Wrapper>
        {loading
          ? Array(5)
              .fill(1)
              .map((_, index) => <TopProductsSkeletonBuilder key={index} />)
          : data?.map((d) => <SparklineBlock {...d} key={d.index} />)}
      </Wrapper>
    </Slide>
  );
};

const Wrapper = styled(DisplayCard.Content)`
  display: grid;
  align-items: center;
  width: 100%;
  gap: 16px;
  grid-template-columns: repeat(5, minmax(200px, 1fr));
  overflow: visible;

  ${breakpoints.before.largeDesktop} {
    grid-template-columns: repeat(3, minmax(200px, 1fr));
  }

  ${breakpoints.before.laptop} {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }

  ${breakpoints.before.mobile} {
    grid-template-columns: minmax(200px, 1fr);
  }
`;
